export class PresLayerOptionalCompatibility {
  /*
  The default behavior for codegen's typescript binding generation is to mark
  all types as required even when they are optionally serialized. This function
  allows for these places to compile, but flags the possibilty that they could
  be dereferencing an undefined value. The callsites of this function should be
  fixed to handle the possibility of an undefined value and then this function
  should be removed.
  */
  public static optionalToRequiredUnsafeCast<Type>(arg: Type | undefined): Type {
    return arg!;
  }
}
